import React from "react";
import { StatementRuleBuilder } from "../StatementRuleBuilder";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { getEmptyDataDefinition, getFilledDataDefinition } from "../../../rule-engine-core/Common/Data/DataTestData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { StatementRuleConfiguration } from "../../../rule-engine-core/Rule/Statement/StatementRuleConfiguration";

export const StatementRuleStories = [
    new StoryNode(
        () => {
            let ruleDefinition = new StatementRuleConfiguration();
            ruleDefinition.inputData = getEmptyDataDefinition();
            return <StatementRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Statement Rule",
        "No Input Data",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = new StatementRuleConfiguration();
            ruleDefinition.inputData = getFilledDataDefinition();

            return <StatementRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Statement Rule",
        "With Input Data",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = new StatementRuleConfiguration();
            ruleDefinition.inputData = () => getFilledDataDefinition();

            return <StatementRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Statement Rule",
        "Read Only Input Data",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = new StatementRuleConfiguration();
            ruleDefinition.executionResult = () => {
                return new NumberDataDefinition("result");
            };

            return <StatementRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Statement Rule",
        "Read Only Output Data",
    ),
];
